module.exports = __webpack_public_path__ + "img/Weapon_293.72723ae5.png";